import { render, staticRenderFns } from "./TraceabilityDetails.vue?vue&type=template&id=6dd47e0a&scoped=true&"
import script from "./TraceabilityDetails.vue?vue&type=script&lang=js&"
export * from "./TraceabilityDetails.vue?vue&type=script&lang=js&"
import style0 from "./TraceabilityDetails.vue?vue&type=style&index=0&id=6dd47e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd47e0a",
  null
  
)

export default component.exports